import { render, staticRenderFns } from "./productCustomSku.vue?vue&type=template&id=a3edd916&scoped=true&"
import script from "./productCustomSku.vue?vue&type=script&lang=js&"
export * from "./productCustomSku.vue?vue&type=script&lang=js&"
import style0 from "./productCustomSku.vue?vue&type=style&index=0&id=a3edd916&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3edd916",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
